import "./style.css";
import ReactDOM from "react-dom/client";
import { Canvas } from "@react-three/fiber";
import Experience from "./Experience.jsx";
import { KeyboardControls } from "@react-three/drei";
import { Interface } from "./Interface.jsx";
import * as THREE from "three";
import { Suspense } from "react";

const root = ReactDOM.createRoot(document.querySelector("#root"));

root.render(
  <KeyboardControls
    map={[
      { name: "moveForward", keys: ["ArrowUp", "KeyW"] },
      { name: "moveBackward", keys: ["ArrowDown", "KeyS"] },
      { name: "moveLeft", keys: ["ArrowLeft", "KeyA"] },
      { name: "moveRight", keys: ["ArrowRight", "KeyD"] },
      { name: "swimFast", keys: ["Shift"] },
      { name: "moveDown", keys: ["KeyC"] },
      { name: "moveUp", keys: ["Space"] },
    ]}
  >
    <Canvas
      dpr={[1, 1.75]} // évite l’oversharp/bruit tout en restant net
      gl={{ antialias: true }} // MSAA si dispo
      shadows={false} // tu as du baked → pas besoin d’ombres runtime
      onCreated={({ gl }) => {
        gl.outputColorSpace = THREE.SRGBColorSpace;
        gl.toneMapping = THREE.ACESFilmicToneMapping;
        gl.toneMappingExposure = 1.0;
      }}
      camera={{
        fov: 45,
        near: 0.1,
        far: 1000,
      }}
    >
      <Suspense fallback={null}>
        <Experience />
      </Suspense>
    </Canvas>
    <Interface />
  </KeyboardControls>
);
